module.exports = __webpack_public_path__ + "img/Rectangle 2395.ba9f6f15.png";